import { useRef, useState } from 'react';
import SearchFilterComponent from '../../../Common/SearchFilterComponent/SearchFilterComponent';
import styles from './index.module.scss';
import ProductList from './product-list';
import AddProductModal from '../../../products/add-product-modal';
import { useEntity } from '../../../../hooks/use-entity.hook';
import { Flaggers } from '../../../../common/store/flaggers/flaggers.enum';
import { FlaggersMethods } from '../../../../common/store/flaggers/flaggers.methods';

const ProductSection = () => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');
  const [searchOnChange, setSearchOnChange] = useState('');
  const [searchOnCross, setSearchOnCross] = useState('');

  const { 
    entityData: addProductModalData, 
    setEntityData: setAddProductModalFlagger 
  } = useEntity<{ show?: boolean; isLoading?: boolean } | null>({ entityType: Flaggers.AddProductModalFlagger });

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  }

  const handleSearchOnCross = () => {
    setSearchValue('');
  }

  const handleAddProduct = () => {
    setAddProductModalFlagger({ show: true }, FlaggersMethods.UpdateFlagger);
  }

  const handleAddProductModalHide = () => {
    setAddProductModalFlagger(null, FlaggersMethods.UpdateFlagger);
  }

  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <SearchFilterComponent 
          leftSide={<div>
            <span className='f-14 line-height-22 f-600 f-black'>Products</span>
          </div>}
          searchValue={searchValue}
          searchOnChange={handleSearchOnChange}
          searchOnCross={handleSearchOnCross}
          passedRef={searchInputRef}
          setRef={() => {
            searchInputRef.current?.focus();
          }}
          lastButtonOnClick={handleAddProduct}
        />
        <ProductList />
      </div>
      <AddProductModal 
        show={!!addProductModalData?.show} 
        onHide={handleAddProductModalHide} 
      />
    </div>
  )
}

export default ProductSection;
